import { render, staticRenderFns } from "./ElectedPublishedContent.vue?vue&type=template&id=54dd61e6&scoped=true"
import script from "./ElectedPublishedContent.vue?vue&type=script&lang=js"
export * from "./ElectedPublishedContent.vue?vue&type=script&lang=js"
import style0 from "./ElectedPublishedContent.vue?vue&type=style&index=0&id=54dd61e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd61e6",
  null
  
)

export default component.exports